import { createSelector } from '@reduxjs/toolkit';
import { ReferentialKey } from 'api/referential';
import { RootState } from 'app/store';

export const selectReferentialData = createSelector(
  (state: RootState) => state.referential.referentialsData,
  referentialsData => referentialsData
);


export const selectReferentialDataByKey = (key: ReferentialKey) =>
  createSelector(
    (state: RootState) => state.referential.referentialsData,
    referentials => referentials[key] || null
  );
